import { defineMessages } from 'react-intl'

export const lang = defineMessages({
    settings: {
        id: 'cards.actions.settings',
        defaultMessage: 'Settings',
    },
})
